import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, type = 'website', image = '/assets/images/company-intro.png', url = 'https://azconstruction.com' }) => {
  const siteUrl = 'https://azconstruction.com';
  const absoluteImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph (Used by Facebook, LinkedIn, Instagram, etc.) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};

export default SEO;
